const ConfigService = function () {
  return {
    config: {},
    /**
     * @var {false|number}
     */
    default_ticketformat_checkout: false,
    /**
     * @var {false|number}
     */
    default_shippingmethod_checkout: false,

    /**
     * @var {false|number}
     */
    email_suggestion_checkout: false,

    setConfig: function (config) {
      this.config = config;

      this.default_ticketformat_checkout = config.default_ticketformat_checkout;
      this.default_shippingmethod_checkout = config.default_shippingmethod_checkout;
      this.email_suggestion_checkout = !!(parseInt(config.email_suggestion_checkout));
      return this;
    }
  };
};

export default ConfigService;
